import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { checkTenantOptionsFromCookies, selectTenantAccess } from "../../../api_calls/requestConfig";
import AccessSelection from "./AccessSelection";

const TenantSelection = ({ open, usedFor, onClose, onWorkspaceSelectionRequired }) => {
  const currentStateData = useSelector((state) => state.userSelections);
  const navigate = useNavigate();
  const cookieTenantOptions = checkTenantOptionsFromCookies();
  const tenantOptions = typeof currentStateData.tenant_options !== "undefined" ? currentStateData.tenant_options : cookieTenantOptions.tenant_options;

  return (
    <AccessSelection
      open={open}
      title="Tenant Selection"
      description="You have access to multiple CAP Explorer tenants. Select which tenant you would like to enter."
      options={tenantOptions}
      initialSelection=""
      showCancel={usedFor === "update"}
      onCancel={onClose}
      onEnter={async (tenantOption) => {
        const switchInfo = await selectTenantAccess(tenantOption, navigate, usedFor);
        if (typeof switchInfo !== "undefined" && switchInfo.success === true && usedFor === "update" && typeof onClose !== "undefined") {
          onClose();

          if (
            switchInfo.show_workspace_list === true &&
            typeof onWorkspaceSelectionRequired !== "undefined"
          ) {
            onWorkspaceSelectionRequired();
          }
        }
      }}
    />
  );
};

export default TenantSelection;
